(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Alternate metafield image: handle infinite scroll newly added cards
  (() => {
    /** @param {HTMLElement} gallery */
    function initAlternateCard(gallery) {
      if (gallery.dataset.metafieldInit) return;
      gallery.dataset.metafieldInit = '1';

      const listItem = gallery.closest('.product-grid__item');
      if (!listItem) return;

      const siblings = Array.from(listItem.parentElement?.children ?? []).filter((el) =>
        el.matches('.product-grid__item')
      );
      const cardIndex = siblings.indexOf(listItem);

      if (cardIndex % 2 === 0) {
        gallery.setAttribute('data-metafield-default', '');
      }
    }

    const grid = document.querySelector('.product-grid--alternate-metafield');
    if (!grid) return;

    new MutationObserver((mutations) => {
      for (const { addedNodes } of mutations) {
        for (const node of addedNodes) {
          if (!(node instanceof HTMLElement)) continue;
          for (const gallery of node.querySelectorAll('[data-metafield-alternate]')) {
            initAlternateCard(gallery);
          }
        }
      }
    }).observe(grid, { childList: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
